<template>
  <div v-bind:class="[selected ? 'light has-text-dark' : 'dark has-text-white', `tab p-1  has-text-centered ${title}`]">
    <h2 class="is-size-5">{{ tabName }}</h2>
  </div>
</template>

<script>

export default {
  name: 'Tab',
  props: ['tabName', 'title', 'selected'],
}
</script>

<style>
.tab {
  display: inline-block;
  width: 50%;
  text-transform: uppercase;
  cursor: pointer;
}

.tab.light {
  background-color: white;
}

.tab.dark {
  background-color: #f2ced2;
  opacity: 75%;
}

.tab.left {
  border-top-right-radius: 16px;
}

.tab.right {
  border-top-left-radius: 16px;
}
</style>
